import { today } from 'owa-datetime';
import { createWeekDateRange, type DateRange } from 'owa-datetime-utils';
import { getUserWeekStartDay } from './getUserWeekStartDay';

export function getDefaultWeekRange(): DateRange {
    return createWeekDateRange(getUserWeekStartDay(), today());
}
